export default __webpack_public_path__ + "static/media/FeaturedBgCrushed.8ef70c10.png";